import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const servicedeskGettingStartedHubsRoute: InvariantJiraRoute = {
	name: 'servicedesk-getting-started-hubs',
	path: '/jira/servicedesk/projects/:projectKey/getting-started/helpcenter/hubs',
	exact: true,
};
